import React from 'react';
import { Route, Switch } from 'wouter';
import { AuthProvider } from './context/AuthContext';
import AuthGuard from './components/auth/AuthGuard';
import AdminGuard from './components/auth/AdminGuard';
import AppNavigation from './components/layout/AppNavigation';
import CheckInApp from './CheckInApp';
import Reports from './Reports';
import ClassManagement from './components/admin/ClassManagement';
import Logout from './Logout';
import './App.css';

function App() {


  return (
    <div data-bs-theme="dark">
      <AuthProvider>
      <AuthGuard>
        <AppNavigation />
        <Switch>
          <Route path="/logout" component={Logout} />
          <Route path="/reports" nest>
            <AdminGuard>
              <Reports />
            </AdminGuard>
          </Route>
          <Route path="/admin/classes">
            <AdminGuard>
              <ClassManagement />
            </AdminGuard>
          </Route>
          <Route component={CheckInApp} />
        </Switch>
      </AuthGuard>
    </AuthProvider>
    </div>
  );
}

export default App;
